// extracted by mini-css-extract-plugin
export default {"title":"App_title__zQTwp","noContacts":"App_noContacts__WS+Ev"};